import { useApp } from "@/store/app";
import { useAuth } from "@/store/auth";
import { linkWebDevice } from "../cloud/auth";
import { registerXmppDevice, fetchCurrentUser } from "@/modules/cloud/auth";
import { getInstallationId } from "@/modules/app/installation";
import Synchronizer from "@/modules/Synchronizer";
import Xmpp from "@/modules/Xmpp";
import clearSession from "./clearSession";

export default function createDeviceSetup() {
  let isNewDevice = true;
  let shouldRelogUser = false;
  let user: any = null;
  let setStatus = useApp.getState().setStatus;
  let setUser = useAuth.getState().setUser;

  const init = () => {
    let canContinue = true;
    const storedUser = window.localStorage.getItem("parseUser");
    const browserUser = storedUser ? JSON.parse(storedUser) : null;
    log.info("user from local storage", browserUser);

    if (!browserUser) {
      setStatus("FAILURE");
      canContinue = false;
    }
    user = browserUser;
    return canContinue;
  };

  const getXmppCredentials = async () => {
    const currentUser = useAuth.getState().user;
    const deviceName = useAuth.getState().device.name;
    let xmppCredentials = useAuth.getState().device.xmppCredentials;
    log.info("xmpp credentials from store", xmppCredentials);

    if (currentUser && currentUser.objectId === user.objectId && currentUser.sessionToken !== user.sessionToken) {
      log.auth("New session token found...");
      shouldRelogUser = true;
      setUser(user);
    }

    if (currentUser && currentUser.objectId !== user.objectId) {
      log.auth("New user found...");
      xmppCredentials = null;
      resetUserSession();
    }

    if (xmppCredentials) {
      isNewDevice = false;
      return xmppCredentials;
    }
    setUser(user);
    await getInstallationId();

    xmppCredentials = await registerXmppDevice(deviceName);
    const response = await linkWebDevice(xmppCredentials.xmppLogin);

    await fetchCurrentUser();

    log.info("Device linked", response);
    return xmppCredentials;
  };

  const syncDevice = async (announcer: Announcer) => {
    const synchronizer = Synchronizer.getInstance();

    if (shouldRelogUser) await transferUserSession();

    if (isNewDevice) {
      announcer.announceChange();
      await synchronizer.synchronize({ syncAll: true });
    } else {
      await synchronizer.synchronize({ syncAlways: ["CLOUD_ACCOUNT"] });
    }
    await Xmpp.getInstance()
      .getRoster()
      .catch((err) => log.app("Roster not loaded, xmpp connection was lost during start", err));
  };

  const transferUserSession = async () => {
    log.auth("Transferring user session...");
    setUser(user);
    const xmppLogin = useAuth.getState().device.xmppCredentials?.xmppLogin;
    if (xmppLogin) await linkWebDevice(xmppLogin);
  };

  const resetUserSession = () => {
    clearSession();
    window.localStorage.setItem("parseUser", JSON.stringify(user));
  };

  return {
    init,
    getXmppCredentials,
    syncDevice
  };
}
